import React from "react";

const ContactAndSources = () => {
  return (
    <main className="main-contactAndSources">
      <h2 style={{ margin: "40px 0 10px 0" }}>
        Contact et sources <br />
      </h2>
      <div className="blocAuteur" style={{ display: "flex" }}>
        {/* <img
          src={FlagAnarchy}
          className="anarchy-flag"
          alt="la propriété c'est le vol"
          style={{ display: "flex" }}
        /> */}
        <p>
          {/* Page de financement participatif : <br />
          <a
            href="https://fr.tipeee.com/deducteur-logique"
            // style={{ color: "" }}
          >
            https://fr.tipeee.com/deducteur-logique
          </a>
          <br /> */}
          <br />
          Si vous avez des remarques, critiques, suggestions,
          <br />
          vous pouvez me les transmettre
          <br />à mleeut@proton.me
        </p>
      </div>
      <div style={{ fontSize: "17px" }}>
        <br />
        Les sources à travers lesquelles j'ai tenté de définir la logique sur ce
        site :<br />- Les cours de logique de l'UFR de philosophie de
        l'Université de Rennes 1, de 2014 à 2018
        <br />
        - De nombreux articles anglais et français de Wikipédia
        <br />
        - yourlogicalfallacyis.com
        <br />- toolkitforthinking.com
        <br />- F.Lepage (2010), <i>Éléments de logique contemporaine</i>,
        Montréal, éd. Presses Universitaires de Montréal, coll. Paramètres, 276
        pages.
        <br />
        Merci à toustes !
      </div>
    </main>
  );
};

export default ContactAndSources;



// WEBPACK FOOTER //
// ./src/components/Pages/Secondary Pages/ContactAndSources.js